<template>
  <a :href="link" class="buy-now__shared">BUY NOW</a>
</template>

<script>
export default {
  props: ['collection'],
  computed: {
    link() {
      return `/${this.$route.params.partner_slug}/checkout/${this.collection.slug}`
    }
  }
}
</script>

<style scoped lang="scss">

</style>
